// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
// https://webpack.js.org/guides/dependency-management/#context-module-api
const requireAll = (requireContext) => {
  return requireContext.keys().map(requireContext);
};

import Rails from "@rails/ujs";
Rails.start();
import Turbolinks from "turbolinks";
Turbolinks.start();
// require("@rails/activestorage").start();
// require("channels");

// Uncomment to copy all static images under ../images to the output folder and reference

// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
